export const ThumbnailConstants = {
  small: {
    width: 256,
    height: 256,
  },
  medium: {
    width: 512,
    height: 512,
  },
  large: {
    width: 1024,
    height: 1024,
  },
};
